import axios, { AxiosResponse } from 'axios'

export const getIp = async () => {
  const res: AxiosResponse = await axios.get('https://api.ipify.org?format=json')
  return res.data.ip
}
